
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default function initScrollSlider() {
    const sliders = document.querySelectorAll('.scroll-slider-block');
    if (!sliders.length) return;

    sliders.forEach(slider => {
        const sections = slider.querySelectorAll('.scroll-slider-section');
        const pagination = slider.querySelector('.scroll-slider-pagination');
        const currentEl = slider.querySelector('.scroll-slider-current');
        
        if (!sections.length) return;

        // Show/Hide pagination based on slider visibility
        if (pagination) {
            ScrollTrigger.create({
                trigger: slider,
                start: 'top 50%',
                end: 'bottom 50%',
                onEnter: () => pagination.classList.remove('is-hidden'),
                onLeave: () => pagination.classList.add('is-hidden'),
                onEnterBack: () => pagination.classList.remove('is-hidden'),
                onLeaveBack: () => pagination.classList.add('is-hidden'),
            });
        }

        // Update current index
        sections.forEach((section, i) => {
            ScrollTrigger.create({
                trigger: section,
                start: 'top 50%',
                end: 'bottom 50%',
                onEnter: () => {
                    if (currentEl) currentEl.textContent = i + 1;
                },
                onEnterBack: () => {
                    if (currentEl) currentEl.textContent = i + 1;
                }
            });
            
            // Optional: Animate content on enter
            const content = section.querySelector('.scroll-slider-content');
            const image = section.querySelector('.scroll-slider-image img');
            
            if (content) {
                gsap.fromTo(content, 
                    { opacity: 0, y: 30 },
                    { 
                        opacity: 1, 
                        y: 0, 
                        duration: 0.8, 
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: section,
                            start: 'top 60%',
                        }
                    }
                );
            }
            
            if (image) {
                gsap.fromTo(image,
                    { scale: 1.1 },
                    {
                        scale: 1,
                        duration: 1.5,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: section,
                            start: 'top 80%',
                        }
                    }
                );
            }
        });
    });
}
